/* eslint-disable linebreak-style */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
import '~/sass/pages/charge.scss';
import Swiper from 'swiper/swiper-bundle';
import Timer from 'easytimer.js';
//charge.js code start

// --- SVG Progress replacement for progressbar.js Circle ---
// class ProgressSvg {
//   constructor(selector, opts = {}) {
//     this.host = document.querySelector(selector);
//     if (!this.host) throw new Error('ProgressSvg host not found: ' + selector);
//     this.opts = Object.assign(
//       { strokeWidth: 6, duration: 5000, color: '#C2EBF2', trailColor: '#fff', size: 28 },
//       opts
//     );
//     this._raf = null;
//     this._value = 0; // 0..1
//     // ensure svg exists inside host
//     this._ensureSvg();
//   }
//   _ensureSvg() {
//     const { size, strokeWidth, color, trailColor } = this.opts;
//     // if already has svg, reuse
//     let svg = this.host.querySelector('svg.progress-ring');
//     if (!svg) {
//       svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//       svg.setAttribute('class', 'progress-ring');
//       svg.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
//       svg.setAttribute('width', size);
//       svg.setAttribute('height', size);
//       // trail
//       const trail = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//       trail.setAttribute('cx', size/2);
//       trail.setAttribute('cy', size/2);
//       trail.setAttribute('r', (size - strokeWidth)/2);
//       trail.setAttribute('fill', 'none');
//       trail.setAttribute('stroke', trailColor);
//       trail.setAttribute('stroke-width', 1);
//       // progress
//       const prog = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//       prog.setAttribute('cx', size/2);
//       prog.setAttribute('cy', size/2);
//       prog.setAttribute('r', (size - strokeWidth)/2);
//       prog.setAttribute('fill', 'none');
//       prog.setAttribute('stroke', color);
//       prog.setAttribute('stroke-width', strokeWidth);
//       prog.setAttribute('stroke-linecap', 'round');
//       prog.setAttribute('transform', 'rotate(-90 ' + size/2 + ' ' + size/2 + ')');
//       svg.appendChild(trail);
//       svg.appendChild(prog);
//       this.host.innerHTML = '';
//       this.host.appendChild(svg);
//     }
//     this.svg = svg;
//     this.circle = this.host.querySelector('circle:last-child');
//     const r = parseFloat(this.circle.getAttribute('r'));
//     this.circumference = 2 * Math.PI * r;
//     this.circle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
//     this._applyValue(this._value);
//   }
//   _applyValue(v) {
//     // clamp
//     v = Math.max(0, Math.min(1, v));
//     this._value = v;
//     const offset = this.circumference * (1 - v);
//     this.circle.style.strokeDashoffset = offset;
//   }
//   value() { return this._value; }
//   set(v) { this._applyValue(v); }
//   animate(target = 1, { duration } = {}) {
//     if (duration == null) duration = this.opts.duration;
//     this.stop();
//     const start = performance.now();
//     const from = this._value;
//     const to = target;
//     const step = (now) => {
//       const t = Math.min(1, (now - start) / duration);
//       const v = from + (to - from) * t;
//       this._applyValue(v);
//       if (t < 1) this._raf = requestAnimationFrame(step);
//     };
//     this._raf = requestAnimationFrame(step);
//   }
//   stop() { if (this._raf) cancelAnimationFrame(this._raf); this._raf = null; }
//   destroy() { this.stop(); this._value = 0; this._applyValue(0); }
// }
// function ensureAllProgressHosts() {
//   document.querySelectorAll('.kv3-navigation-item .dot-wrap > div, .kv5-navigation-item .dot-wrap > div')
//     .forEach((el) => {
//       if (!el.classList.contains('progress-host')) el.classList.add('progress-host');
//       // Make sure SVG structure exists
//       try { new ProgressSvg('.' + Array.from(el.classList).join('.')); } catch(e) {}
//     });
// }
// --- end SVG Progress replacement ---

const { $ } = window;

let swiperA = null;
let swiperB = null;
let bar1;
let timer1 = null;
let timer1IsPaused = false;
let bar2;
let timer2 = null;
let timer2IsPaused = false;

function initSwiperA() {
  swiperA = new Swiper('#swiperA', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
  if ($(window).width() >= 768) {
    swiperA.destroy(true);
    $('#swiperA').removeClass('swiper');
    $('#swiperA').children('.swiper-wrapper').removeClass('swiper-wrapper');
    $('#swiperA').children('div').children('.img-item').removeClass('swiper-slide');
  }
}
function initSwiperB() {
  swiperB = new Swiper('#swiperB', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
  if ($(window).width() >= 768) {
    swiperB.destroy(true);
    $('#swiperB').removeClass('swiper');
    $('#swiperB').children('.swiper-wrapper').removeClass('swiper-wrapper');
    $('#swiperB').children('div').children('.img-item').removeClass('swiper-slide');
  }
}
// function initBar1() {
//   bar1 = new ProgressSvg('.kv3-active', {
//     strokeWidth: 6,
//     easing: 'linear',
//     duration: 5000,
//     color: '#C2EBF2',
//     trailColor: '#fff',
//     trailWidth: 1,
//     svgStyle: null,
//   });
//   bar1.animate(1);
// }
// function initBar2() {
//   bar2 = new ProgressSvg('.kv5-active', {
//     strokeWidth: 6,
//     easing: 'linear',
//     duration: 5000,
//     color: '#C2EBF2',
//     trailColor: '#fff',
//     trailWidth: 1,
//     svgStyle: null,
//   });
//   bar2.animate(1);
// }
function swiperAActive() {
  const nodeA = $('#swiperA').children('.img-wrap-wrapper');
  if (nodeA[0].children[0].classList.contains('active')) {
    nodeA[0].children[0].classList.remove('active');
    nodeA[0].children[1].classList.add('active');
    $('.kv3-navigation-item')[0].children[0].classList.remove('active');
    $('.kv3-navigation-item')[0].children[1].classList.add('active');
    $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
    bar1.destroy();
    $('.kv3-navigation-item')[0].children[1].children[0].classList.add('kv3-active');
    //initBar1();
  } else if (nodeA[0].children[1].classList.contains('active')) {
    nodeA[0].children[1].classList.remove('active');
    nodeA[0].children[2].classList.add('active');
    $('.kv3-navigation-item')[0].children[1].classList.remove('active');
    $('.kv3-navigation-item')[0].children[2].classList.add('active');
    $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
    bar1.destroy();
    $('.kv3-navigation-item')[0].children[2].children[0].classList.add('kv3-active');
    //initBar1();
  } else if (nodeA[0].children[2].classList.contains('active')) {
    nodeA[0].children[2].classList.remove('active');
    nodeA[0].children[3].classList.add('active');
    $('.kv3-navigation-item')[0].children[2].classList.remove('active');
    $('.kv3-navigation-item')[0].children[3].classList.add('active');
    $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
    bar1.destroy();
    $('.kv3-navigation-item')[0].children[3].children[0].classList.add('kv3-active');
    //initBar1();
  } else if (nodeA[0].children[3].classList.contains('active')) {
    nodeA[0].children[3].classList.remove('active');
    nodeA[0].children[0].classList.add('active');
    $('.kv3-navigation-item')[0].children[3].classList.remove('active');
    $('.kv3-navigation-item')[0].children[0].classList.add('active');
    $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
    bar1.destroy();
    $('.kv3-navigation-item')[0].children[0].children[0].classList.add('kv3-active');
    //initBar1();
  }
}
function swiperBActive() {
  const ndoeB = $('#swiperB').children('.img-wrap-wrapper');
  if (ndoeB[0].children[0].children[0].classList.contains('active')) {
    ndoeB[0].children[0].children[0].classList.remove('active');
    ndoeB[0].children[1].children[0].classList.add('active');
    $('.kv5-navigation-item')[0].children[0].classList.remove('active');
    $('.kv5-navigation-item')[0].children[1].classList.add('active');
    $('.kv5-navigation-item')[0].children[0].children[0].classList.remove('kv5-active');
    bar2.destroy();
    $('.kv5-navigation-item')[0].children[1].children[0].classList.add('kv5-active');
    //initBar2();
  } else if (ndoeB[0].children[1].children[0].classList.contains('active')) {
    ndoeB[0].children[1].children[0].classList.remove('active');
    ndoeB[0].children[2].children[0].classList.add('active');
    $('.kv5-navigation-item')[0].children[1].classList.remove('active');
    $('.kv5-navigation-item')[0].children[2].classList.add('active');
    $('.kv5-navigation-item')[0].children[1].children[0].classList.remove('kv5-active');
    bar2.destroy();
    $('.kv5-navigation-item')[0].children[2].children[0].classList.add('kv5-active');
    //initBar2();
  } else if (ndoeB[0].children[2].children[0].classList.contains('active')) {
    ndoeB[0].children[2].children[0].classList.remove('active');
    ndoeB[0].children[0].children[0].classList.add('active');
    $('.kv5-navigation-item')[0].children[2].classList.remove('active');
    $('.kv5-navigation-item')[0].children[0].classList.add('active');
    $('.kv5-navigation-item')[0].children[2].children[0].classList.remove('kv5-active');
    bar2.destroy();
    $('.kv5-navigation-item')[0].children[0].children[0].classList.add('kv5-active');
    //initBar2();
  }
}
function pauseSwiper(dom, timer, bar) {
  timer.pause();
  bar.stop();
  $(dom).children('.controls').css('opacity', '0');
  $(dom).children('.fa-play').css('opacity', '1');
}
function startSwiper(dom, timer, bar) {
  timer.start({ precision: 'seconds' });
  bar.set(bar.value());
  bar.animate(1, {
    duration: (5 - timer.getTimeValues().seconds) * 1000,
  });
  $(dom).children('.controls').css('opacity', '1');
  $(dom).children('.fa-play').css('opacity', '0');
}

$(document).ready(() => {
  //ensureAllProgressHosts();
  //initBar1();
  //initBar2();
  // swiper handler
  timer1 = new Timer();
  timer1.start({ precision: 'seconds' });
  timer1.addEventListener('secondsUpdated', () => {
    if (timer1.getTimeValues().seconds === 5) {
      swiperAActive();
    }
    if (timer1.getTimeValues().seconds >= 5) {
      timer1.reset();
    }
  });
  timer2 = new Timer();
  timer2.start({ precision: 'seconds' });
  timer2.addEventListener('secondsUpdated', () => {
    if (timer2.getTimeValues().seconds === 5) {
      swiperBActive();
    }
    if (timer2.getTimeValues().seconds >= 5) {
      timer2.reset();
    }
  });
  initSwiperA();
  initSwiperB();
  $('#kv3-controls').on('click', () => {
    timer1IsPaused = !timer1IsPaused;
    if (timer1IsPaused) {
      pauseSwiper('#kv3-controls', timer1, bar1);
    } else {
      startSwiper('#kv3-controls', timer1, bar1);
    }
  });
  $('#kv5-controls').on('click', () => {
    timer2IsPaused = !timer2IsPaused;
    if (timer2IsPaused) {
      timer2.pause();
      bar2.stop();
      $('#kv5-controls').children('.controls').css('opacity', '0');
      $('#kv5-controls').children('.fa-play').css('opacity', '1');
    } else {
      timer2.start({ precision: 'seconds' });
      bar2.set(bar2.value());
      bar2.animate(1, {
        duration: (5 - timer2.getTimeValues().seconds) * 1000,
      });
      $('#kv5-controls').children('.controls').css('opacity', '1');
      $('#kv5-controls').children('.fa-play').css('opacity', '0');
    }
  });
  $('#kv3-dot1').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[0].classList.contains('active')) {
      nodeA[0].children[0].classList.add('active');
      nodeA[0].children[1].classList.remove('active');
      nodeA[0].children[2].classList.remove('active');
      nodeA[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].classList.add('active');
      $('.kv3-navigation-item')[0].children[1].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[0].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv3-step1').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[0].classList.contains('active')) {
      nodeA[0].children[0].classList.add('active');
      nodeA[0].children[1].classList.remove('active');
      nodeA[0].children[2].classList.remove('active');
      nodeA[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].classList.add('active');
      $('.kv3-navigation-item')[0].children[1].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[0].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv3-dot2').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[1].classList.contains('active')) {
      nodeA[0].children[1].classList.add('active');
      nodeA[0].children[0].classList.remove('active');
      nodeA[0].children[2].classList.remove('active');
      nodeA[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].classList.add('active');
      $('.kv3-navigation-item')[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[1].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv3-step2').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[1].classList.contains('active')) {
      nodeA[0].children[1].classList.add('active');
      nodeA[0].children[0].classList.remove('active');
      nodeA[0].children[2].classList.remove('active');
      nodeA[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].classList.add('active');
      $('.kv3-navigation-item')[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[1].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv3-dot3').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[2].classList.contains('active')) {
      nodeA[0].children[2].classList.add('active');
      nodeA[0].children[1].classList.remove('active');
      nodeA[0].children[0].classList.remove('active');
      nodeA[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.add('active');
      $('.kv3-navigation-item')[0].children[1].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[2].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv3-step3').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[2].classList.contains('active')) {
      nodeA[0].children[2].classList.add('active');
      nodeA[0].children[1].classList.remove('active');
      nodeA[0].children[0].classList.remove('active');
      nodeA[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.add('active');
      $('.kv3-navigation-item')[0].children[1].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[3].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[2].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv3-dot4').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[3].classList.contains('active')) {
      nodeA[0].children[3].classList.add('active');
      nodeA[0].children[1].classList.remove('active');
      nodeA[0].children[2].classList.remove('active');
      nodeA[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.add('active');
      $('.kv3-navigation-item')[0].children[1].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[3].children[0].classList.add('kv3-active');
      initBar1();
      timer1.reset();
    }
  });
  $('#kv3-step4').on('click', () => {
    const nodeA = $('#swiperA').children('.img-wrap-wrapper');
    if (!nodeA[0].children[3].classList.contains('active')) {
      nodeA[0].children[3].classList.add('active');
      nodeA[0].children[1].classList.remove('active');
      nodeA[0].children[2].classList.remove('active');
      nodeA[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[3].classList.add('active');
      $('.kv3-navigation-item')[0].children[1].classList.remove('active');
      $('.kv3-navigation-item')[0].children[2].classList.remove('active');
      $('.kv3-navigation-item')[0].children[0].classList.remove('active');
      $('.kv3-navigation-item')[0].children[1].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[2].children[0].classList.remove('kv3-active');
      $('.kv3-navigation-item')[0].children[0].children[0].classList.remove('kv3-active');
      bar1.destroy();
      $('.kv3-navigation-item')[0].children[3].children[0].classList.add('kv3-active');
      //initBar1();
      timer1.reset();
    }
  });
  $('#kv5-dot1').on('click', () => {
    const nodeA = $('#swiperB').children('.img-wrap-wrapper');
    if (!nodeA[0].children[0].children[0].classList.contains('active')) {
      nodeA[0].children[0].children[0].classList.add('active');
      nodeA[0].children[1].children[0].classList.remove('active');
      nodeA[0].children[2].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[0].classList.add('active');
      $('.kv5-navigation-item')[0].children[1].classList.remove('active');
      $('.kv5-navigation-item')[0].children[2].classList.remove('active');
      $('.kv5-navigation-item')[0].children[1].children[0].classList.remove('kv5-active');
      $('.kv5-navigation-item')[0].children[2].children[0].classList.remove('kv5-active');
      bar2.destroy();
      $('.kv5-navigation-item')[0].children[0].children[0].classList.add('kv5-active');
      //initBar2();
      timer2.reset();
    }
  });
  $('#kv5-step1').on('click', () => {
    const nodeA = $('#swiperB').children('.img-wrap-wrapper');
    if (!nodeA[0].children[0].children[0].classList.contains('active')) {
      nodeA[0].children[0].children[0].classList.add('active');
      nodeA[0].children[1].children[0].classList.remove('active');
      nodeA[0].children[2].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[0].classList.add('active');
      $('.kv5-navigation-item')[0].children[1].classList.remove('active');
      $('.kv5-navigation-item')[0].children[2].classList.remove('active');
      $('.kv5-navigation-item')[0].children[1].children[0].classList.remove('kv5-active');
      $('.kv5-navigation-item')[0].children[2].children[0].classList.remove('kv5-active');
      bar2.destroy();
      $('.kv5-navigation-item')[0].children[0].children[0].classList.add('kv5-active');
      //initBar2();
      timer2.reset();
    }
  });
  $('#kv5-dot2').on('click', () => {
    const nodeA = $('#swiperB').children('.img-wrap-wrapper');
    if (!nodeA[0].children[1].children[0].classList.contains('active')) {
      nodeA[0].children[1].children[0].classList.add('active');
      nodeA[0].children[0].children[0].classList.remove('active');
      nodeA[0].children[2].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[1].classList.add('active');
      $('.kv5-navigation-item')[0].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[2].classList.remove('active');
      $('.kv5-navigation-item')[0].children[0].children[0].classList.remove('kv5-active');
      $('.kv5-navigation-item')[0].children[2].children[0].classList.remove('kv5-active');
      bar2.destroy();
      $('.kv5-navigation-item')[0].children[1].children[0].classList.add('kv5-active');
      //initBar2();
      timer2.reset();
    }
  });
  $('#kv5-step2').on('click', () => {
    const nodeA = $('#swiperB').children('.img-wrap-wrapper');
    if (!nodeA[0].children[1].children[0].classList.contains('active')) {
      nodeA[0].children[1].children[0].classList.add('active');
      nodeA[0].children[0].children[0].classList.remove('active');
      nodeA[0].children[2].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[1].classList.add('active');
      $('.kv5-navigation-item')[0].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[2].classList.remove('active');
      $('.kv5-navigation-item')[0].children[0].children[0].classList.remove('kv5-active');
      $('.kv5-navigation-item')[0].children[2].children[0].classList.remove('kv5-active');
      bar2.destroy();
      $('.kv5-navigation-item')[0].children[1].children[0].classList.add('kv5-active');
      //initBar2();
      timer2.reset();
    }
  });
  $('#kv5-dot3').on('click', () => {
    const nodeA = $('#swiperB').children('.img-wrap-wrapper');
    if (!nodeA[0].children[2].children[0].classList.contains('active')) {
      nodeA[0].children[2].children[0].classList.add('active');
      nodeA[0].children[1].children[0].classList.remove('active');
      nodeA[0].children[0].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[2].classList.add('active');
      $('.kv5-navigation-item')[0].children[1].classList.remove('active');
      $('.kv5-navigation-item')[0].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[1].children[0].classList.remove('kv5-active');
      $('.kv5-navigation-item')[0].children[0].children[0].classList.remove('kv5-active');
      bar2.destroy();
      $('.kv5-navigation-item')[0].children[2].children[0].classList.add('kv5-active');
      //initBar2();
      timer2.reset();
    }
  });
  $('#kv5-step3').on('click', () => {
    const nodeA = $('#swiperB').children('.img-wrap-wrapper');
    if (!nodeA[0].children[2].children[0].classList.contains('active')) {
      nodeA[0].children[2].children[0].classList.add('active');
      nodeA[0].children[1].children[0].classList.remove('active');
      nodeA[0].children[0].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[2].classList.add('active');
      $('.kv5-navigation-item')[0].children[1].classList.remove('active');
      $('.kv5-navigation-item')[0].children[0].classList.remove('active');
      $('.kv5-navigation-item')[0].children[1].children[0].classList.remove('kv5-active');
      $('.kv5-navigation-item')[0].children[0].children[0].classList.remove('kv5-active');
      bar2.destroy();
      $('.kv5-navigation-item')[0].children[2].children[0].classList.add('kv5-active');
      //initBar2();
      timer2.reset();
    }
  });
  // anchor handler
  $('.section1-anchor').on('click', () => {
    window.scrollTo({ top: $('#section1').offset().top - 72, behavior: 'smooth' });
  });
  $('.section2-anchor').on('click', () => {
    window.scrollTo({ top: $('#section2').offset().top - 72, behavior: 'smooth' });
  });
  $('.section3-anchor').on('click', () => {
    window.scrollTo({ top: $('#section3').offset().top - 72, behavior: 'smooth' });
  });
  $('#scroll-kv3').on('click', () => {
    window.scrollTo({ top: $('#section3').offset().top - 72, behavior: 'smooth' });
  });
  $('#scroll-kv3-m').on('click', () => {
    window.scrollTo({ top: $('#section3').offset().top - 72, behavior: 'smooth' });
  });
  $('.section4-anchor').on('click', () => {
    window.scrollTo({ top: $('#section4').offset().top - 72, behavior: 'smooth' });
  });
  $('#scroll-kv4').on('click', () => {
    window.scrollTo({ top: $('#section4').offset().top - 72, behavior: 'smooth' });
  });
  $('#scroll-kv4-m').on('click', () => {
    window.scrollTo({ top: $('#section4').offset().top - 72, behavior: 'smooth' });
  });
  document.addEventListener('scroll', () => {
    if (window.scrollY < $('#section2').offset().top - 72) {
      $('.section1-anchor').addClass('active');
      $('.section2-anchor').removeClass('active');
      $('.section3-anchor').removeClass('active');
      $('.section4-anchor').removeClass('active');
    }
    if (window.scrollY < $('#section3').offset().top - 72 && window.scrollY >= $('#section2').offset().top - 72) {
      $('.section1-anchor').removeClass('active');
      $('.section2-anchor').addClass('active');
      $('.section3-anchor').removeClass('active');
      $('.section4-anchor').removeClass('active');
    }
    if (window.scrollY < $('#section4').offset().top - 72 && window.scrollY >= Math.round($('#section3').offset().top - 72)) {
      $('.section1-anchor').removeClass('active');
      $('.section2-anchor').removeClass('active');
      $('.section3-anchor').addClass('active');
      $('.section4-anchor').removeClass('active');
    }
    if (window.scrollY >= Math.round($('#section4').offset().top - 72)) {
      $('.section1-anchor').removeClass('active');
      $('.section2-anchor').removeClass('active');
      $('.section3-anchor').removeClass('active');
      $('.section4-anchor').addClass('active');
    }
  }, true);

  $('.charge-map-wrap').on('click', () => {
    window.open('/bZ/map.aspx', '_blank');
  });
  $('#yt1').on('click', () => {
    window.open('https://youtu.be/BRSxZj2A-HI');
  });
  $('#yt2').on('click', () => {
    window.open('https://youtu.be/0D0j9ta4Erg');
  });
  $('#kv4-video').on('click', () => {
    $('iframe')[0].setAttribute('src', 'https://www.youtube.com/embed/JNIJvp-sJAc');
    $('.video-mask').css('display', 'flex');
  });
  $('.video-close').on('click', () => {
    $('iframe')[0].setAttribute('src', '');
    $('.video-mask').css('display', 'none');
  });
});
//charge.js code end